import styled from 'styled-components'

/**
 * Layout lifted from the prototype's DV360/Meta AdTech media guide
 * (github.com/vtex/ads-design-prototypes, feat/offsite, apps/offsite/v2.html
 * — `.dv360-guide-*` rules), the more recent of two guide layouts in that
 * file — the other (single-column sections) is the one this component
 * originally copied and is what's being replaced here. Content stays
 * whatever this MVR1 already decided (Image + Mobile, 500 KB — see
 * SizeGuide.tsx); only the chrome (2-column grid, icon tiles) changes.
 */
export const GuideBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sl-space-4);

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

// Spans both columns so the "minimum creatives" tip sits above the groups.
export const GuideTip = styled.div`
  grid-column: 1 / -1;
`

export const GuideGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--sl-space-3);
  min-width: 0;
`

export const GuideGroupIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-accent);
  color: var(--sl-fg-accent);
`

export const GuideGroupTitle = styled.h4`
  margin: 0 0 var(--sl-space-2);
  font: var(--sl-text-emphasis-font);
  color: var(--sl-fg-base);
`

export const GuideList = styled.ul`
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);

  li::marker {
    color: var(--sl-fg-base-soft);
  }
`
